import React, { useEffect, useMemo, useState } from 'react';
import { Field, ErrorMessage } from 'formik';
import { IoMdArrowDropdown } from 'react-icons/io';
import InputFieldComponent from '../common/FormComponents/InputFieldComponent';
import getPpeKit from '../ppe/queries/getPpeKit';
import showAlert from '../../utils/alert';
import DropdownFieldComponent from '../common/FormComponents/DropdownFieldComponent';
import getAllPpeComponent from '../ppe/queries/getAllPpeComponent';
import VesselPPETable from './VesselPPETable';

const VesselAdhocPPE = ({ id, setFieldValue, expenseCategoryList, mode,
index, crew, values, errors, touched, restoredPpeCategoryDetails, isCrewPage }) => {
  const [ppeListFinal, setppeListFinal] = useState([]);
  const [show, setShow] = useState(false);
  const oldCrew = useMemo(() => crew?.crewCode, []);
  const [columns, setColumns] = useState([]);
  const [newItem, setNewItem] = useState({ item: '', size: '', quantity: '', totalPrice: 0, unitPrice: 0, unitPriceUsd: 0, componentMasterId: '' });
  const { mutate: getPpeKitList, data: ppeList } = getPpeKit();
  const [itemOptions, setItemOptions] = useState([]);
  const [sizeOptions, setSizeOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState();
  const [adhocList, setAdhocList] = useState([]);

  useEffect(() => {
    if (restoredPpeCategoryDetails?.restoredPpeDetails?.length > 0) {
      const data = restoredPpeCategoryDetails?.restoredPpeDetails;
      setAdhocList(restoredPpeCategoryDetails
      ?.restoredPpeDetails?.length > 0 ? [...data] : [...adhocList]);
    }
}, []);
const getAllPpeComponents = async () => {
    const adhocDropDownData = await getAllPpeComponent(null);
    setItemOptions(adhocDropDownData.data.items);
  };
useEffect(() => {
getAllPpeComponents();
}, []);
  useEffect(() => {
    if (crew?.crewCode && crew?.expenseLineItemId && crew?.plannedVesselId) {
      if (mode === 'edit') {
      getPpeKitList(crew);
      }
    }
    if (oldCrew !== crew?.crewCode) {
      setppeListFinal([]);
    }
  }, [crew?.crewCode, crew?.expenseLineItemId, crew?.plannedVesselId]);
  useEffect(() => {
    if (!ppeList) {
      setppeListFinal(adhocList);
     const finalArray = Array.isArray(adhocList)
      ? adhocList
      : adhocList
        ? [adhocList]
        : [];
      setFieldValue(`purchaseOrderCrew[${index}].ppeCategoryDetails`, finalArray);
    } if (oldCrew !== crew?.crewCode) {
      if (crew?.expenseLineItemId && ppeList?.status === 204) {
       setppeListFinal(adhocList);
       setFieldValue(`purchaseOrderCrew[${index}].ppeCategoryDetails`, ...adhocList);
       return;
      }
    }
    if (restoredPpeCategoryDetails?.restoredPpeDetails?.length > 0) {
      if (restoredPpeCategoryDetails?.plannedVesselId === crew.plannedVesselId) {
      const val = [...adhocList];
        setppeListFinal(val);
      } else {
        const val = [...adhocList];
        setFieldValue(`purchaseOrderCrew[${index}].ppeCategoryDetails`, val);
        setppeListFinal(val);
      }
      } else if (crew?.ppeCategoryDetails?.length > 0) {
        setppeListFinal(crew?.ppeCategoryDetails);
      } else {
        setppeListFinal([...adhocList]);
      }
  }, [ppeList, crew?.plannedVesselId]);
  useEffect(() => {
    setFieldValue(`purchaseOrderCrew[${index}].ppeCategoryDetails`, ppeListFinal);
    if (crew?.expenseLineItemId) {
      if (ppeListFinal.length > 0) {
      if (values?.currencyId === 1) {
      setColumns(['Item', 'Size', 'Quantity', 'Unit Price(INR)', 'Total Price(INR)']);
      const amount = ppeListFinal
      ?.reduce((acc, item) => acc + item?.quantity * item?.unitPrice, 0).toFixed(2);
            setFieldValue(`purchaseOrderCrew[${index}].amount`, Number(amount).toFixed(2));
      } else {
      setColumns(['Item', 'Size', 'Quantity', 'Unit Price(USD)', 'Total Price(USD)']);
        const amount = ppeListFinal
        ?.reduce((acc, item) => acc + item?.quantity * item?.unitPriceUsd, 0).toFixed(2);
      setFieldValue(`purchaseOrderCrew[${index}].amount`, Number(amount).toFixed(2));
      }
    } else {
      setFieldValue(`purchaseOrderCrew[${index}].amount`, '');
    }
    }
  }, [ppeListFinal, crew?.expenseLineItemId, values?.currencyId]);
  const category = expenseCategoryList?.find(({ expenseCategoryID }) => expenseCategoryID === id);
  const hanldeDelete = (items, ind) => () => {
   const newPPEList = ppeListFinal?.filter((i, idx) => idx !== ind);
    setppeListFinal([...newPPEList]);
    setAdhocList(newPPEList);
  };
   useEffect(() => {
      touched?.purchaseOrderCrew?.forEach((item, val) => {
      if (index === val) {
      if (item?.ppeCategoryDetails?.length === 0) {
        setShow(true);
      }
    }
    });
  }, [touched]);
 const handleAddItem = () => {
  if (newItem.item && (!selectedOption?.sizable || newItem.size) && newItem.quantity > 0) {
    const isDuplicate = ppeListFinal?.some(
      (ppe) => ppe.componentName === newItem.item
    );
    const isDuplicateVesselPo = !isCrewPage
    && ppeListFinal?.some(
    (ppe) => ppe.componentName === newItem.item
    && ppe.measurement === newItem.size
  );

  if (!isCrewPage && isDuplicateVesselPo) {
  showAlert('This item with the same size already exists!', 'error');
  return;
   }
    if (isCrewPage && isDuplicate) {
      showAlert('Item already exists!', 'error');
      return;
    }
    const newPPE = {
      componentName: newItem.item,
      measurement: newItem.size,
      quantity: newItem.quantity,
      componentMasterId: newItem.componentMasterId,
      totalPrice: values?.currencyId === 1
        ? newItem.quantity * newItem.unitPrice
        : newItem.quantity * newItem.unitPriceUsd,
      unitPrice: newItem.unitPrice,
      unitPriceUsd: newItem.unitPriceUsd
    };
    setAdhocList([...adhocList, newPPE]);
    setppeListFinal([...values?.purchaseOrderCrew[0]?.ppeCategoryDetails, newPPE]);
    setNewItem({ item: '', size: '', quantity: '' });
    setFieldValue('AdhocItem', '');
    setSizeOptions([]);
    setSelectedOption('');
    setFieldValue('size', '');
    setFieldValue('quantity', '');
  } else {
    showAlert('Please fill all fields before adding!', 'error');
  }
};
  const handleInputChange = (field, value) => {
    setNewItem((prev) => ({ ...prev, [field]: value }));
  };
  const handleItemChange = (val) => {
    setFieldValue('size', '');
    handleInputChange('item', val?.name);
    handleInputChange('componentMasterId', val?.id);
    handleInputChange('unitPrice', val?.unitPrice);
    handleInputChange('unitPriceUsd', val?.unitPriceUsd);
    const selectedItem = itemOptions.find((item) => item.name === val?.name);
    setSelectedOption(selectedItem);
    if (selectedItem?.sizable) {
      setSizeOptions(selectedItem.measurement);
    } else {
      setSizeOptions([]);
    }
  };
  const isDisabled = crew?.isShortClosed
  || crew?.invoiceStatus?.toLowerCase().includes('payment')
  || crew?.invoiceStatus?.toLowerCase().includes('voucher')
  || crew?.invoiceStatus?.toLowerCase().includes('transferred');
  const isButtonDisabled = !ppeListFinal || isDisabled;
  return (
    <>
      {((!isCrewPage || crew?.crewCode) && crew?.expenseLineItemId) && (
      <div className="capitalize pt-8 font-extrabold text-base">
        <div className="cursor-pointer flex justify-between bg-white-dark p-2 text-sm adhoc-item-color" onClick={() => setShow(!show)}>
        {!isCrewPage
        ? 'PPE'
        : `${category?.categoryName} - Adhoc Item`}
          <span
            className={`rotatable ${show ? 'expanded' : 'collapsed'}`}
          >
            <IoMdArrowDropdown size={25} />
          </span>
        </div>
        <hr />
      </div>
      )}
    {((!isCrewPage || crew?.crewCode) && crew?.expenseLineItemId && show) && (
        <>
          <div className="flex-col justify-start items-start">
            <div>
<>
<div className="p-1 mb-4">
<ErrorMessage
  name={`purchaseOrderCrew[${index}].ppeCategoryDetails`}
  render={() => (
    <div className="text-red-500 text-sm font-medium">
      Please enter all mandatory fields.
    </div>
  )}
  className="text-red-500 text-sm font-medium"
/>
<div className="grid grid-cols-10 gap-6 p-1 relative">
  <div className="col-span-3">
    <Field
      name="AdhocItem"
      component={DropdownFieldComponent}
      className="w-full"
      setChangedValue={(val) => handleItemChange(val)}
      onChange={() => handleItemChange()}
      options={itemOptions.map((item) => ({ label: item.name, value: item }))}
      id="adhocItem"
      requiredField
      isDisabled={isDisabled}
      rounded
      isClearable
      type="text"
      placeholder=""
      label="Item"
    />
  </div>
  <div className="col-span-3">
    <Field
      name="size"
      value={newItem.size}
      options={sizeOptions.map((size) => ({ label: size, value: size }))}
      setChangedValue={(val) => handleInputChange('size', val)}
      component={DropdownFieldComponent}
      className="w-full"
      isClearable
      isDisabled={isDisabled}
      requiredField={selectedOption?.sizable}
      rounded
      type="text"
      placeholder=""
      label="Size"
    />
  </div>
<div className="col-span-3">
                <Field
                  name="quantity"
                  component={InputFieldComponent}
                  setChangedValue={(val) => handleInputChange('quantity', val)}
                  className="w-full"
                  requiredField
                  min={1}
                  onInput={(e) => {
                    handleInputChange('quantity', e.target.value);
                  }}
                  size="large"
                  disabled={isDisabled}
                  rounded
                  id="quantity"
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  label="Quantity"
                />
</div>
<div
className="flex justify-end items-center"
>
    <button
        type="button"
        className="adhoc-add-btn w-10 h-10 rounded-full flex items-center justify-center disabled:opacity-50"
        disabled={isButtonDisabled}
        onClick={handleAddItem}
    >
      <span className="text-2xl">+</span>
    </button>
</div>
</div>
</div>
</>
            </div>
          </div>
  {ppeListFinal?.length > 0 && (
<VesselPPETable
  ppeListFinal={ppeListFinal}
  crew={crew}
  values={values}
  setAdhocList={setAdhocList}
  errors={errors}
  touched={touched}
  itemOptions={itemOptions}
  setppeListFinal={setppeListFinal}
  setFieldValue={setFieldValue}
  index={index}
  hanldeDelete={(item, ind) => hanldeDelete(item, ind)}
  columns={columns}
/>
)}
        </>
      )}
    </>
  );
};

export default VesselAdhocPPE;
